module.exports = __webpack_public_path__ + "img/home-img-art-history.44ef00ed.jpg";